__turbopack_context__.v({
  "copy": "Hi2WXW_copy",
  "cta": "Hi2WXW_cta",
  "primary": "Hi2WXW_primary",
  "status": "Hi2WXW_status",
  "term": "Hi2WXW_term",
  "tip": "Hi2WXW_tip",
});
